import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

// About eight lines; a longer question scrolls inside the box
const MAX_HEIGHT = 200;

/** The box a question to GPS AI is typed in. Enter sends it; Shift+Enter starts a new line. */
@Component({
    selector: 'app-chat-composer',
    templateUrl: './chat-composer.component.html',
    styleUrls: ['./chat-composer.component.scss'],
})
export class ChatComposerComponent implements OnChanges {
    @Input() placeholder: string = 'How can I help you today?';
    /** An answer is on its way: a question can be typed but not sent */
    @Input() busy: boolean = false;
    /** What is in the box. Given by a page that keeps a question not yet sent, and gives it back */
    @Input() text: string = '';
    @Output() textChange = new EventEmitter<string>();
    @Output() send = new EventEmitter<string>();

    @ViewChild('input') private input: ElementRef<HTMLTextAreaElement>;

    get canSend(): boolean {
        return !this.busy && this.text.trim().length > 0;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.text) {
            // Once the box has been given it
            setTimeout(() => this.resize());
        }
    }

    onType(text: string): void {
        this.text = text;
        this.textChange.emit(text);
    }

    submit(): void {
        if (!this.canSend) {
            return;
        }
        this.send.emit(this.text.trim());
        this.onType('');
        // Once the box has been emptied
        setTimeout(() => this.resize());
    }

    onEnter(event: Event): void {
        const key = event as KeyboardEvent;
        // Enter also picks a suggestion while composing text in an input method
        if (key.shiftKey || key.isComposing) {
            return;
        }
        event.preventDefault();
        this.submit();
    }

    /** Grow with the question, up to a point. */
    resize(): void {
        const box = this.input?.nativeElement;
        if (box) {
            box.style.height = 'auto';
            box.style.height = `${Math.min(box.scrollHeight, MAX_HEIGHT)}px`;
        }
    }

    focus(): void {
        this.input?.nativeElement.focus();
    }
}
